import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const defaultProps = {
  className: ''
};

export default class PageSection extends Component {
  render() {
    const classes = [this.props.className, 'rec-section-outer-wrap'].filter((v) => v !== "").join(' ');

    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
}

PageSection.propTypes = propTypes;
PageSection.defaultProps = defaultProps;
